import React from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
// Ust
import { useInvAF } from "../../../../St/Reviews/UseStyle";
// csG
import { stElemnt } from "../../../../St/Reviews/cStyle";

import { colors, Container, makeStyles, Typography } from "@material-ui/core";
import { useBody } from "../../invCompany/style";
import { txtA, txtE } from "../../../../Label/Lbl";
import InvTotal from "../../AFReadyDisigen/A4/InvTotal";
import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { Rept } from "../../../../Context/InshData";
const BodyInv = (props) => {
  const cls = useRptAF();
  //   const { onUnmountComplete, data } = props;
  const { onUnmountComplete, data, isFullPage, isLast, sum, inv, sta ,locInv} = props;


  const clas = useInvAF();
  const calssBody = useBody();
  //   const islast=(data?.length )

  const cellS = {

    padding: "0px 0px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.7rem",
    width: "300px",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };

  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

  var columns2 = [
    { title: "No \n م", field: "no" },
    // { title:premiApp.billTemplate !== 9?"Barcode \n الباركود":"No Item \n الرقم", field: "barcode" },
    { title: "Item Name \n اسم الصنف", field: "symbol1", cellStyle: cellS },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Qoantity \n الكمية ", field: "val1" },
    {
      title: "Price \n السعر ",
      field: "new_exchange_price",

    },
    // { title: txtA.taxableAmount, field: "totBill" },

    { title: "Discount \n الخصم", field: "discount" },
    { title: "BeforeVat" + "\n" + "الخاضع للضريبة", field: "totBill" },

    // { title: txtA.taxRate, field: "taxperc" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];

  var columns = [
    { title: "No \n م", field: "no" },
    // { title:premiApp.billTemplate !== 9?"Barcode \n الباركود":"No Item \n الرقم", field: "barcode" },
    { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: cellS },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Qoantity \n الكمية ", field: "val1" },
    {
      title: "Price \n السعر ",
      field: "new_exchange_price",

    },
    // { title: txtA.taxableAmount, field: "totBill" },

    { title: "Discount \n الخصم", field: "discount" },
    { title: "BeforeVat" + "\n" + "الخاضع للضريبة", field: "totBill" },

    // { title: txtA.taxRate, field: "taxperc" },
    { title: "VatAmount \n مبلغ الضريبة", field: "taxval" },
    { title: "NetAmount \n شامل الضريبة", field: "tot_net_curr" },
  ];

  const mergColumn = (symbol, nameEN) => {
    if (nameEN != null && nameEN != "") {
      return `${nameEN} \n ${symbol}`
    } else {
      return `${symbol}`
    }
  };

  const data2 = data.map((row, i) => {
    return {
      ...row,
      id: i + 1,
      symbol1: mergColumn(row.symbol, row.nameEN),
      totBill: new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(row.totBill),
      new_exchange_price: row.exchange_price.toFixed(locInv?.NRound??4),
      amountAfterDisc: new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(row.amountAfterDisc),
      tot_net_curr: new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(row?.tot_net_curr),
      discount: new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(row?.discount),
    };
  });

  return (
    <Grid item container className={cls.rootBdy}>
      <Grid item container //className={cls.rootBdyup}
        style={{
          paddingTop: "0.5rem", direction: "rtl", border: "dotted 1px #393939",
        }}>
        <Grid
          item
          xs={12}
          style={{
            //  maxHeight: isFullPage ? sum >1 ? isLast?  "38em" :"40em" :"38em" :"38em" ,
            // minHeight: isFullPage ? sum >1 ? isLast?  "35em" :"40em" :"38em" :"38em" ,
            maxHeight: "31rem",
            minHeight: "31rem",

          }}
        >
          <MaterialTable
            style={{ boxShadow: "none" }}
            // style={{direction:'ltr'}}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0px",
                border: "solid 0.1px",


              },
              paging: false,
              // headerStyle: { ...stElemnt.AF.header, backgroundColor: "grey" },
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 1px",
                // fontSize: 8,
              },
              // maxBodyHeight: isFullPage ? "56.3rem" : "35.6rem",
              // minBodyHeight: isFullPage ? "56.3rem" : "35.6rem",
            }}
            localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
            columns={premiApp.billTemplate === 16 ? (columns2.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))) : columns.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            }))}
            data={data2}
          />
          {premiApp.billTemplate !== 19 &&
            (
              <Grid item xs={12} className={clas.BdytotCntMmm} style={{ textAlign: "right" }}>
                {inv.notes}
              </Grid>
            )}
          {isLast && <InvTotal inv={inv} sta={sta} />}
        </Grid>
        {/* <Grid item xs={12}>
        </Grid> */}
      </Grid>

    </Grid>
  );
};

export default BodyInv;
